import { MouseEventHandler } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  isAvailable: boolean;
  isRxProduct: boolean;
  handleOnClick: MouseEventHandler<HTMLButtonElement>;
  productLink: string;
}

export const ProductCTA = (props: Props) => {
  const { t } = useTranslation();
  return (
    <>
      {(props.isAvailable && !props.isRxProduct) ? (
          <button
            type="button"
            className="button button--primary button_text_small product-card__cta-button"
            onClick={props.handleOnClick}
            aria-label={t("search.hits.buttons.addToCart") as string}
          >
            {t("search.hits.buttons.addToCart")}
          </button>

      ) : (
          <a
            className="button button--primary button_text_small product-card__cta-button"
            href={props.productLink}
            aria-label={t("search.hits.buttons.openProduct") as string}
          >
            {t("search.hits.buttons.openProduct")}
          </a>
      )}
    </>
  );
};
